export default __webpack_public_path__ + "static/media/github-run-workflow.939ca4a4.png";